/**
 * Email Overflow Detection
 *
 * Uses max-content measurement technique for precise overflow detection
 */

export class EmailOverflow {
	constructor() {
		this.checkOverflow();
		window.addEventListener("resize", () => this.checkOverflow());
	}

	checkOverflow() {
		document.querySelectorAll(".cards-grid").forEach((grid) => {
			grid.classList.remove("cards-grid--email-buttons");

			const hasOverflow = [...grid.querySelectorAll(".card__email--text")].some(
				(email) => {
					const card = email.closest(".card");
					const cardWidth = card.getBoundingClientRect().width;
					const originalMaxWidth = email.style.maxWidth;
					email.style.maxWidth = "max-content";
					const naturalWidth = email.getBoundingClientRect().width;
					email.style.maxWidth = originalMaxWidth;

					return naturalWidth > cardWidth * 0.99;
				}
			);

			grid.classList.toggle("cards-grid--email-buttons", hasOverflow);
		});
	}
}
